import * as React from 'react';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import ListItemText from '@mui/material/ListItemText';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';

import SearchIcon from "@mui/icons-material/Search";
import MailIcon from "@mui/icons-material/Mail";
import ChatBubbleIcon from "@mui/icons-material/ChatBubble";
import Tooltip from '@mui/material/Tooltip';
import IconButton from "@mui/material/IconButton"
import NavigationIcon from '@mui/icons-material/Navigation';
import FilterAltIcon from '@mui/icons-material/FilterAlt';

import PrecisionManufacturingIcon from '@mui/icons-material/PrecisionManufacturing';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};

const icons = [CalendarMonthIcon, CalendarTodayIcon, PrecisionManufacturingIcon, LocalShippingIcon]
const names = [
    'Forecast Mensal',
    'Forecast Diário',
    'Lançamento de Produção',
    'Requisição de Compras'
];

export default function MultipleSelectCheckmarks() {
    const [personName, setPersonName] = React.useState<string[]>([]);

    const handleChange = (event: SelectChangeEvent<typeof personName>) => {
        const {
            target: { value },
        } = event;
        setPersonName(
            // On autofill we get a stringified value.
            typeof value === 'string' ? value.split(',') : value,
        );
    };

    return (
        <div>
            <FormControl sx={{ width: '100%' }}>
                <InputLabel id="demo-multiple-checkbox-label" >Filtrar Registros</InputLabel>
                <Select
                    labelId="demo-multiple-checkbox-label"
                    id="demo-multiple-checkbox"
                    multiple
                    value={personName}
                    onChange={handleChange}
                    input={<OutlinedInput label="Filtrar Registros" />}
                    renderValue={(selected) => selected.join(', ')}
                    MenuProps={MenuProps}
                    size='small'
                    fullWidth
                >
                    {names.map((name, index) => (
                        <MenuItem key={name} value={name}>
                            <Checkbox size='small' checked={personName.indexOf(name) > -1} />
                            <ListItemText aria-setsize={8} primary={name} />
                            {index === 0 ? <CalendarMonthIcon /> : index === 1 ? <CalendarTodayIcon /> : index === 2 ? <PrecisionManufacturingIcon /> : index === 3 ? <LocalShippingIcon /> : <LocalShippingIcon />}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </div>
    );
}